// Loading placeholders: one presentational row per row of the page, the table's only progress indicator.
// When loading ends, focus returns to the control that started the request.

import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import { useTable } from '../context'
import { restoreAfterRequest } from './focusTarget'

/** `count` replaces the page size where an instance has no pages (grouped mode). */
export const SkeletonRows = ({ count = null }) => {
  const { state, layout, refs, initiator } = useTable()

  // the request this loading belongs to, read when loading ends
  const latest = useRef({ initiator, unit: refs && refs.unit })
  latest.current = { initiator, unit: refs && refs.unit }
  useEffect(
    () => () =>
      restoreAfterRequest(latest.current.initiator, latest.current.unit),
    []
  )

  return Array.from({ length: count || state.pageSize }, (_, i) => (
    <tr
      key={`skeleton-${i}`}
      className="me-table-skeleton-row"
      aria-hidden="true"
    >
      {Array.from({ length: layout.columnCount }, (__, j) => (
        <td key={j}>
          <span
            className="me-table-skeleton"
            style={{ width: `${45 + ((i * 7 + j * 13) % 45)}%` }}
          />
        </td>
      ))}
    </tr>
  ))
}

SkeletonRows.propTypes = {
  count: PropTypes.number,
}
